import { checkers } from "vincent-utils";
export const hasEmailReminderTarget = (patient) => patient.email_consent !== false &&
    !!patient.email &&
    checkers.isEmail(patient.email);
export const hasSmsReminderTarget = (patient) => patient.sms_consent !== false && !!patient.portablee164;
export const hasRemindersTargets = (patient) => hasEmailReminderTarget(patient) || hasSmsReminderTarget(patient);
export const hasConfirmationTarget = (patient) => hasSmsReminderTarget(patient);
//# sourceMappingURL=remindersTargets.js.map